import Popup from "reactjs-popup";
import FormInput from "../../form-input/form-input.component";
import "./transfer-popup.style.scss";
import { useState } from "react";
import BeatSpinner from "../../loading-indicator/beat-loader";
import validateEmail from "../../../utils/email-validation/email-validation";
import { FaArrowLeft } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { AiOutlineCamera } from "react-icons/ai";
import profileImageUploadReq, {
  PROFILE_URL,
} from "../../../utils/profile-image/upload-profile";
import generateTransferTicketOTP from "../../../apis/generate-transfer-ticket-OTP";
import verifyTransferTicket from "../../../apis/verify-transfer-ticket";
import getSignedImageUrl from "../../../apis/get-signed-imageUrl";
import updateTransferTicketStatus from "../../../apis/update-transfer-ticket-status";

export const TransferViewType = {
  INFO_VIEW: "INFO_VIEW",
  VERIFY_EMAIL_VIEW: "VERIFY_EMAIL_VIEW",
  EMAIL_VERIFIED_VIEW: "EMAIL_VERIFIED_VIEW",
};

export const TransferPopup = ({
  showPopup,
  onClosePressed,
  onSubmitted,
  onTicketInfoUpdated,
  onlyUpdateImage,
  data,
}) => {
  const defaultFormFields = {
    fullName: "",
    email: "",
    otp: "",
  };

  const [newFormFields, setNewFormFields] = useState(defaultFormFields);
  const [isSubmitting, setIsSubmitting] = useState(false); // state for submit button loading
  const [viewType, setViewType] = useState(TransferViewType.INFO_VIEW);
  const [errorMessage, setErrorMessage] = useState("");
  const [image, setImage] = useState(PROFILE_URL);
  const [imageInput, setImageInput] = useState(null);
  const [signedImageUrl, setSignedImageUrl] = useState("");
  const { fullName, email, otp } = newFormFields;
  const onCloseHandler = () => {
    onClosePressed();
    setNewFormFields(defaultFormFields);
    setImageInput(null);
    setImage(PROFILE_URL);
  };

  const handleKeyPress = (event) => {
    const pattern = /^\d{0,4}$/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar) || event.target.value.length >= 4) {
      event.preventDefault();
    }
  };

  // image change function
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onHanldeUpdateImageOnly = async (e) => {
    e.preventDefault();

    if (image === PROFILE_URL) {
      throw new Error("Please Upload your image and try again");
    }
    setIsSubmitting(true);
    const singedData = await getSignedImageUrl(data.id);
    const uploadedImage = await profileImageUploadReq(
      image,
      singedData.signedUrl
    );
    if (uploadedImage.ok) {
      await updateTransferTicketStatus(
        data.event?.id,
        data.uniqueHash,
        singedData.signedKey
      )
        .then(() => {
          onTicketInfoUpdated();
        })
        .catch((err) => {
          setErrorMessage(
            err.response ? err.response.data.message : err.message
          );
          setIsSubmitting(false);
        });
      setTimeout(() => setErrorMessage(""), 3000);
    }
    setIsSubmitting(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newFormFields.fullName.trim()) {
      alert("Full Name cannot be empty!");
      return;
    } else if (!validateEmail(email)) {
      alert("Please enter a valid email");
      return;
    } else {
      setIsSubmitting(true);
      try {
        await generateTransferTicketOTP(
          data.event?.id,
          data.uniqueHash,
          newFormFields.fullName,
          newFormFields.email
        );
        setViewType(TransferViewType.VERIFY_EMAIL_VIEW);
      } catch (err) {
        setErrorMessage(err.response ? err.response.data.message : err.message);
      } finally {
        setTimeout(() => setErrorMessage(""), 3000);
        setIsSubmitting(false);
      }
    }
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    const updatedFormFields = { ...newFormFields, [name]: value };
    setNewFormFields(updatedFormFields);
  };

  function onBackPressed() {
    setViewType(TransferViewType.INFO_VIEW);
    setNewFormFields({ ...newFormFields, otp: "" });
  }

  const onVerifyOTPPressed = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log(
      "data ",
      data.event?.id,
      data.uniqueHash,
      newFormFields.fullName,
      newFormFields.email,
      otp
    );
    try {
      const response = await verifyTransferTicket(
        data.event?.id,
        data.uniqueHash,
        newFormFields.fullName,
        newFormFields.email,
        otp
      );
      onSubmitted(response);
      setIsSubmitting(false);
    } catch (err) {
      console.error(err.response ? err.response.data.message : err.message);
      setErrorMessage(err.response ? err.response.data.message : err.message);
      setTimeout(() => setErrorMessage(""), 4000);
    } finally {
      setIsSubmitting(false);
    }
  };

  function renderVerifyEmailView() {
    return (
      <div className="otp-screen">
        <div className="back-arrow-container">
          <FaArrowLeft onClick={onBackPressed} />
        </div>

        <div className="email-icon-container">
          <MdEmail size={50} />
        </div>

        <div className="verification-messages-container">
          <p className="email-verification-message">Verify email</p>
          <p className="email-verification-message-two">
            In order to transfer the ticket, Please verify a 4-digit code sent
            to {email},
          </p>
        </div>

        <form key={errorMessage} onSubmit={onVerifyOTPPressed}>
          <FormInput
            label="OTP"
            type="number"
            placeholder="OTP"
            name="otp"
            value={otp}
            onChange={onChangeHandler}
            onKeyPress={handleKeyPress}
            required
          />
          <span className="error-message-container">{errorMessage}</span>

          <button className="sign-in-button" onClick={onVerifyOTPPressed}>
            {isSubmitting ? <BeatSpinner /> : "Verify"}
          </button>
        </form>
      </div>
    );
  }

  function renderInfoView() {
    return (
      <form
        key={errorMessage}
        onSubmit={onlyUpdateImage ? onHanldeUpdateImageOnly : handleSubmit}
      >
        <h2 className="custom-popup-heading">
          {!onlyUpdateImage && !data.isTransfered
            ? "Please enter information"
            : "Please upload your picture"}
        </h2>
        {onlyUpdateImage && (
          <div className="profile-image-container">
            <img src={image} alt="Profile" />
            <input
              type="file"
              id="image-input"
              accept="image/*"
              onChange={handleImageChange}
              ref={(input) => setImageInput(input)}
              style={{ display: "none" }}
            />

            <button
              className="change-image-btn"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                imageInput.click();
              }}
            >
              <AiOutlineCamera size={20} />
            </button>
          </div>
        )}
        {!onlyUpdateImage && (
          <FormInput
            label="Full Name"
            type="text"
            placeholder="Full Name"
            name="fullName"
            value={fullName}
            onChange={onChangeHandler}
            required
          />
        )}

        {!onlyUpdateImage && (
          <FormInput
            label="Email"
            type="text"
            placeholder="Email"
            name="email"
            value={email}
            onChange={onChangeHandler}
            required
          />
        )}
        <span className="error-message-container">{errorMessage}</span>

        <div className="buttons-container">
          <button className="cancel-button" onClick={onCloseHandler}>
            Cancel
          </button>

          <button className="sign-in-button">
            {isSubmitting ? (
              <BeatSpinner color="white" />
            ) : !onlyUpdateImage && !data.isTransfered ? (
              "Continue"
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </form>
    );
  }

  return (
    <Popup
      open={showPopup}
      closeOnDocumentClick={false}
      closeOnEscape={false}
      overlayStyle={{
        transitionDelay: "1000",
        background: "rgba(0, 0, 0, 0.5)",
      }}
      contentStyle={{
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        margin: "auto",
        background: "rgb(255, 255, 255)",
        width: "300px",
        height: !data.isInfoUpdatedAfterTransfer
          ? "300px"
          : viewType === TransferViewType.INFO_VIEW
          ? "400px"
          : "320px",
        padding: "20px",
      }}
      arrowStyle={{
        color: "rgb(255, 255, 255)",
      }}
    >
      {viewType === TransferViewType.INFO_VIEW && renderInfoView()}
      {viewType === TransferViewType.VERIFY_EMAIL_VIEW &&
        renderVerifyEmailView()}
    </Popup>
  );
};
